<template lang="pug">
  #CustomerTempTextModel.CustomerModel.CustomerModel-tempTextModel.p-3(
    :class="{ 'CustomerModel-active': showModel }",
    :style="[{Zindex: Zindex}, modelCSS]"
  )
    .row.align-items-start.mb-2
      .col-10
        h2.mb-0 {{ title }}
      .col-2
        img.rounded-circle.closeIcon(
          v-lazy="iconUrl.IconClose",
          fluid,
          alt="Close Icon",
          @click="closeModel()"
        )
    .content.mb-2
      template(
          v-for="(temp,index) in finalSendTemps"
        )
          //- 文字
          b-card.border-0.customerCard.tempInput(
            bg-variant="light",
            v-if='temp.push_format.type === "text"'
          )
            .text-right.mb-2
              i.fas.fa-times-circle.fa-lg(
                @click="deleteTempHandler(temp.id, temp.type)"
              )
            b-form-textarea(
              rows="5",
              v-model="temp.push_format.text"
            )
            small.text-muted.text-right.d-block 文字數：{{ temp.push_format.text ? temp.push_format.text.length : 0 }}
          //- 影像地圖
          image-map-input(
            v-if='temp.push_format.type === "imageMap"',
            :key="temp.id",
            :index='index',
            :originalData="temp",
            :selectMode="false",
            :deleteMode="true"
          )
          //- 橫向捲軸
          carousel-input(
            v-if='temp.push_format.type === "carousel"',
            :key="temp.id",
            :index='index',
            :originalData="temp",
            :selectMode="false",
            :deleteMode="true"
          )
    .px-4
      .row
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="closeModel()"
          ) 返回上頁
        .col-6
          button.btn.btn-block.btn-primary(
            type="button",
            @click="submitHandler()"
          ) 確認送出

</template>

<script>
import { mapState } from 'vuex';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'TempSendPreviewModel',
  components: {
    textInput,
    imageMapInput,
    carouselInput
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    Zindex: {
      type: String,
      default: '15px'
    },
    modelCSS: {
      type: Object,
      default: null
    },
    previewTemps: {
      type: Array,
      require: true
    },
    user: {
      type: [Object, null],
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      finalSendTemps: []
    };
  },
  mounted() {
    const vm = this;
    vm.$EventBus.$on('openTempSendPreviewModel', () => {
      vm.openModel();
    });
  },
  methods: {
    initHandler() {
      this.finalSendTemps = null;
      this.finalSendTemps = _.cloneDeep(this.previewTemps);
    },
    openModel() {
      this.initHandler();
      this.showModel = true;
    },
    closeModel() {
      this.$emit('scrollToTarget');
      this.finalSendTemps = null;
      this.showModel = false;
    },
    async submitHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '模板送出中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      const data = await _.map(vm.finalSendTemps, (val) => ({
          id: val.id,
          template: val.type,
          text: val.push_format.type === 'text' ? val.push_format.text : null
        }));

      let sendData;

      // 群發
      if (vm.multicastPush) {
        sendData = {
          to: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
          templates: data
        };
      } else if (!vm.multicastPush) {
        sendData = {
          member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
          templates: data
        };
      } else {
        return;
      }

      vm.$store.dispatch(`sa_chat/${vm.multicastPush ? 'templatesMulticastPushHandler' : 'templatesPushHandler'}`, sendData)
        .then(() => {
          vm.$emit('closeModelHandler');
          vm.closeModel();
          vm.$swal.close();
          vm.$snotify.success(null, '模板送出成功');
        });
    },
    deleteTempHandler({ id, template }) {
      const vm = this;
      if (vm.finalSendTemps.length === 1) {
        vm.$swal.fire({
          icon: 'error',
          title: '至少需要選擇一則模板'
        });
      } else {
        vm.$swal.fire({
          title: '您確定取消傳送這個模板?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          reverseButtons: true,
          customClass: {
            confirmButton: 'btn btn-primary px-5'
          }
        }).then((result) => {
          if (result.value) {
            const finalSendTemps_key = _.findKey(vm.finalSendTemps, (val) => val.id === id && val.type === template);
            vm.finalSendTemps.splice(finalSendTemps_key, 1);
          }
        });
      }
    }
  },
  computed: {
    ...mapState({
      temps: (state) => state.sa_temp.temps,
      pagination: (state) => state.sa_temp.pagination
    })
  },
  beforeDestroy() {
    this.$EventBus.$off('openTempSendPreviewModel');
  }
};
</script>

<style>

</style>
